import QuizCard from './QuizCard';

export default QuizCard;
